import React from 'react';
import { useParams } from 'react-router-dom';
import LearningBoardEditor from 'components/learning/board/LearningBoardEditor';
import { TSubjectLayout, TLearningParams } from 'modules/learning';
import { ERoute } from 'enums/route.enum';
import styled from 'styled-components';
import { device } from 'GlobalStyles';

const SubjectTemplate = ({ pageTitle, pageSubtitle, children }: TSubjectLayout) => {
  const { category, operation } = useParams<TLearningParams>();

  return (
    <>
      {(operation === 'view' || !operation) && (
        <StyledContainer>
          <StyledPageTitle>{pageTitle}</StyledPageTitle>
          <StyledPageSubtitle>{pageSubtitle}</StyledPageSubtitle>
          {children}
        </StyledContainer>
      )}

      {operation === 'create' && (
        <LearningBoardEditor pathName={`${ERoute.CSLearningBoard}/${category}/view`} operation={operation} />
      )}
    </>
  );
};

export default SubjectTemplate;

const StyledContainer = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f9f9f9;
`;

const StyledPageTitle = styled.h1`
  margin-top: 60px;
  margin-bottom: 0;
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  line-height: 40px;
  color: #14112a;

  @media screen and ${device.md} {
    width: 280px;
    font-size: 20px;
    line-height: 28px;
  }
`;

const StyledPageSubtitle = styled.p`
  width: 592px;
  margin-top: 10px;
  margin-bottom: 0px;
  font-size: 18px;
  text-align: center;

  @media screen and ${device.md} {
    width: 280px;
    font-size: 14px;
    line-height: 28px;
  }
`;
